<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop" >
            <div class="banner_title"> <span class="color3"></span> Seamless Travel Payments with Minglepay: Powering Your Business Growth</div>
            <div class="banner_tips mt-40 fw-300">Unlock the full potential of your travel business with Minglepay’s cutting-edge payment platform. Designed for simplicity, speed, and scalability, we put your customers and growth first.</div>
         </div>
       </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Why Choose Minglepay for Travel Payments?</div> 
            </div>
            <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_xs_12 grid_sm_12" v-for="tab in tabList" :key="tab.id" :class="tab.id==5?'grid_md_12':'grid_md_6'">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img :src="tab.icon" alt="" class="">
                        </div>
                        <div class="half_title color2">{{ tab.title }}</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">{{ tab.msg }}</div>
                    </div>
                </div>
              </div>
          </div>  
      
        </div>
      </div>
    </div>

    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">Your All-in-One Payment Partner</div>
                <div class="title_tag color1">Minglepay is a global leader in travel payment solutions and open banking. From transaction management to real-time financial insights, our platform empowers travel agencies with a robust, connected payment ecosystem.</div>
            </div>
        </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
        
        
           <div class="py-20" >
            <div class="page_title pt-30">
                <div class="title_name color2 ">FAQs</div>   
            </div>
            <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                     <div class="faq_collapse">
                        <el-collapse v-model="activeName" accordion>
                          <el-collapse-item title="What is open banking?" name="1">
                            <div class="coll_item">Open banking allows traditional banks to share data securely with licensed fintech providers like Minglepay, enabling faster, more efficient transactions for your business.</div> 
                          </el-collapse-item>
                          <el-collapse-item title="How fast are transactions processed?" name="2">
                           <div class="coll_item">With Minglepay, payments are processed instantly, and funds appear in your account within minutes.</div>
                          </el-collapse-item>
                          <el-collapse-item title="Can Minglepay support my growing business?" name="3">
                           <div class="coll_item">Absolutely. Our scalable plans are designed to adapt to your business needs, from small startups to large enterprises.</div>
                          </el-collapse-item>
                       
                        </el-collapse>
                      </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t20.png" alt="">
                  </div>
                </div>

            </div>
          </div>
          <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t51.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Transform Your Travel Business Today</div>
                        <div class="title_tag color6 text-l">With Minglepay, you get more than a payment platform—you get a partner dedicated to your success. Connect with us to streamline your payments and fuel your growth.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>


   
  </div>
</template>

<script>
import tab1 from '../../assets/image/tb34.png'
import tab2 from '../../assets/image/tb35.png'
import tab3 from '../../assets/image/tb36.png'
import tab4 from '../../assets/image/tb37.png'
import tab5 from '../../assets/image/tb38.png'


export default {
    data(){
        return{
          
          
            activeName:'1',
            tabList:[
                {title:"Flexible, Scalable Solutions",msg:"Tailored for travel businesses of all sizes, our plans grow with you. Whether you're a startup or an established agency, Minglepay provides the tools to scale seamlessly.",id:1,icon:tab1},
                {title:"Instant Transactions",msg:"Experience lightning-fast payments. Funds are transferred and reflected in your account in minutes, keeping your operations smooth and efficient.",id:2,icon:tab2},
                {title:"Smart AI-Powered Insights",msg:"Leverage advanced AI and machine-learning to gain actionable financial analytics, optimize transaction flows, and enhance customer experiences.",id:3,icon:tab3},
                {title:"User-Friendly APIs",msg:"Integrate our intuitive APIs to bring your travel products to market quickly and efficiently, with minimal technical hassle.",id:4,icon:tab4},
                {title:"Open Banking Excellence",msg:"Our platform connects seamlessly with major banks across the UK and EU, enabling secure, streamlined transactions through open banking. We make merchant services effortless, so you can focus on your customers.",id:5,icon:tab5},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg9.png);
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}

</style>